import * as PIXI from 'pixi.js';
import Library, { TextureLibraryEntry, HatLibraryEntry, SoundLibraryEntry, PrefabLibraryEntry } from '.';
import AssetManager from '../AssetManager';

class LibraryManager {
    constructor() {
        this.textures = new Library('Plaatjes');
        this.hats = new Library('Hoofddeksels');

        this.sounds = new Library('Geluidjes');
        this.prefabs = new Library('Bouwstenen');

        this.recentPrefabs = [];
        this.amountOfRecentPrefabs = 11;
    }

    addRecentPrefab(prefabId) {
        if (this.recentPrefabs[0] === prefabId) return false;
        this.recentPrefabs.unshift(prefabId);
        for (let i = 1; i < this.amountOfRecentPrefabs; i++) {
            if (this.recentPrefabs[i]) {
                if (this.recentPrefabs[i] === prefabId) {
                    this.recentPrefabs.splice(i, 1);
                    break;
                }
            }
        }
        if (this.recentPrefabs.length - this.amountOfRecentPrefabs > 0) this.recentPrefabs.splice(this.amountOfRecentPrefabs, this.recentPrefabs.length - this.amountOfRecentPrefabs);
        return true;
    }

    fill(loader, data, settings) {
        this._fillLib(this.textures, loader, data.textures, TextureLibraryEntry, 'Patronen en plaatjes ophalen', (item, entry, loadList) => {
            const id = `textures.${item.id}`;
            loadList.push({ id, url: settings.textures + item.file });
            entry.asset = id;
        });
        this._fillLib(this.hats, loader, data.hats, HatLibraryEntry, 'Hoofddeksels ophalen', (item, entry, loadList) => {
            const idSide = `hats.${item.id}_side`;
            loadList.push({ id: idSide, url: settings.hats + item.side.file });
            entry.assetSide = idSide;
            const idTop = `hats.${item.id}_top`;
            loadList.push({ id: idTop, url: settings.hats + item.top.file });
            entry.assetTop = idTop;
        });
        this._fillLib(this.sounds, loader, data.sounds, SoundLibraryEntry, 'Geluidjes ophalen', (item, entry, loadList) => {
            const id = `sounds.${item.id}`;
            loadList.push({ id, url: settings.sounds + item.file });
            entry.asset = id;
        });
        this._fillLib(this.prefabs, loader, data.prefabs, PrefabLibraryEntry, 'Bouwstenen ophalen', (item, entry, loadList) => {
            const id = `previews.${item.id}`;
            if (item.preview.indexOf('.png') !== -1) {
                loadList.push({ id, url: settings.previews + item.preview });
                entry.preview = id;
            }
        });
    }

    _fillLib(lib, loader, data, type, loadText, handleItem) {
        const assetLoadList = [];
        for (let i = 0; i < data.length; i++) {
            const category = lib.createCategory(data[i].title);
            if (data[i].description) category.description = data[i].description;
            for (let j = 0; j < data[i].items.length; j++) {
                const item = data[i].items[j];
                const entry = new type(item.id, null);
                entry.deserialize(item);
                category.addItem(entry);
                if (handleItem) {
                    handleItem(item, entry, assetLoadList);
                }
            }
        }

        if (assetLoadList.length > 0) {
            loader.addStage(loadText, assetLoadList.length, (finish, error, update) => {
                const assetLoaderInfo = AssetManager.loadDatabase(assetLoadList, () => {
                    finish();
                });
                assetLoaderInfo.onLoaded = () => {
                    const lastLoaded = assetLoaderInfo.loadedAssets[assetLoaderInfo.loadedAssets.length - 1];
                    if (lastLoaded) {
                        if (lastLoaded.image) lastLoaded.image.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
                    }
                    if (assetLoaderInfo.errors.length > 0) {
                        error(assetLoaderInfo.errors);
                    } else update(assetLoaderInfo.loadCount);
                };
            });
        }
    }
}

export default new LibraryManager();
